export default {
  viewType: 'show-fei-shu-document',
  breadcrumb: { title: '', action: '', class: '' },
  params: {}
}
